import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';

import { ArrowLink } from './Links';
import * as styles from './NotificationBar.module.css';

/* eslint-disable */
const NotificationBar = ({ meta, settings }) => {
  let showNotificationBar;

  const [closed, setClosed] = useState(true);

  let label = settings.notificationBarLabel ? settings.notificationBarLabel : '';
  let link = settings.notificationBarUrl ? settings.notificationBarUrl : '';

  if (meta.displayNotificationBar) {
    showNotificationBar = true;
    label = meta.notificationBarOverrideLabel ? meta.notificationBarOverrideLabel : '';
    link = meta.notificationBarOverrideUrl ? meta.notificationBarOverrideUrl : '';
  } else if (settings.notificationBarDisplayAllPages) {
    showNotificationBar = true;
  } else {
    showNotificationBar = false;
  }

  if ((label === '' && link === '') || settings.overrideIndividualPageNotifications) {
    label = settings.notificationBarLabel;
    link = settings.notificationBarUrl;
  }

  const closeNotificationBar = () => {
    setClosed(true);
    Cookies.set('notification_bar_close', true);
    showNotificationBar = false;
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (Cookies.get('notification_bar_close')) {
      // const isClosed = Cookies.get('notification_bar_close');
      closeNotificationBar();
    } else {
      setClosed(false);
      Cookies.remove('notification_bar_close');
    }
  }, [closed]);

  const display = !closed && showNotificationBar;
  const metaColor = meta?.notificationBarColor;
  const siteColor = settings.notificationBarColor;

  const color = metaColor || siteColor || 'FS Pink';
  const colors = {
    'FS Pink': styles.fsPink,
    Blue: styles.blue,
    Spark: styles.spark,
  };

  return (
    <div
      className={[colors[color], styles.notifyBar, display ? styles.show : styles.hide].join(' ')}
      style={{
        display: showNotificationBar ? 'flex' : 'none',
      }}
    >
      <div className={styles.notifyBarText} onClick={closeNotificationBar}>
        <ArrowLink className={styles.bounceArrow} label={label} url={link} isArrowRight isExternal role="button" />
        <div className={styles.crossIcon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
            <path
              d="M1.38513 1.47278L14 14.8861"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14 1.47278L1.38513 14.8861"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export { NotificationBar };
